import { Calendar, CalendarDays, CalendarRange } from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { MyWorkordersView } from '@/features/user-preferences/user-preferences.hooks';
import { cn } from '@/lib/utils';

interface ViewModeToggleProps {
  mode: MyWorkordersView;
  onChange: (mode: MyWorkordersView) => void;
}

const MODES: {
  value: MyWorkordersView;
  label: string;
  Icon: typeof Calendar;
}[] = [
  { value: 'day', label: 'Day', Icon: CalendarDays },
  { value: 'week', label: 'Week', Icon: CalendarRange },
  { value: 'month', label: 'Month', Icon: Calendar },
];

export function ViewModeToggle({ mode, onChange }: ViewModeToggleProps) {
  return (
    <div className="bg-muted inline-flex items-center rounded-md p-0.5">
      {MODES.map(({ value, label, Icon }) => (
        <Button
          key={value}
          type="button"
          variant="ghost"
          size="sm"
          onClick={() => onChange(value)}
          className={cn(
            'h-7 px-2',
            mode === value
              ? `bg-background dark:bg-accent text-foreground dark:border-input border
                border-transparent shadow-sm`
              : 'text-muted-foreground hover:text-foreground',
          )}
          aria-pressed={mode === value}
        >
          <Icon className="hidden h-4 w-4 sm:mr-1 sm:block" />
          {label}
        </Button>
      ))}
    </div>
  );
}
